import { withInstall } from "@xplus/utils/with-install";
import image from "./src/image.vue";
export const xImage = withInstall(image);
export default xImage;
export * from "./src/image";
